import { createContext, useContext } from 'react';
export const BiometricsPluginContext = createContext(null);
export const BiometricsConfigProvider = BiometricsPluginContext.Provider;
export const useBiometricsConfig = () => useContext(BiometricsPluginContext);